import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@brand';
import { Button, message } from 'antd';
import styles from "./LoginPage.module.css";
import { useUserContext } from '../../components/UserContext/UserContext';
import { useMsal } from '@azure/msal-react';
import { handleLogin as handleLoginFlow } from '../../utils/auth';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const { setUserProfile } = useUserContext();
  const [isLoading, setIsLoading] = useState(false);
  
  const handleLogin = async () => {
    setIsLoading(true);
    try {
      const isContainer = !window.location.hostname.includes('localhost');
      if (isContainer) {
        message.info("Redirecting to login...");
      }
      
      await handleLoginFlow(instance, accounts, setUserProfile, navigate);
    } catch (error: any) {
      console.error("Login error:", error);
      message.error(error.message || "Login failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.loginPage}>
      <div className={styles.chatIcon}>
        <Icon width={62} height={70} />
      </div>
      <h1>Welcome to Our Virtual Assistant Admin Portal</h1>
      <Button 
        onClick={handleLogin} 
        className={styles.loginButton} 
        type="primary"
        loading={isLoading}
        disabled={isLoading}
      >
        {isLoading ? "Signing in..." : "Login"}
      </Button>
    </div>
  );
};

export default LoginPage;
